<template>
    <div class="user-info" v-loading="loading">
        <div class="collect-head">
            <SearchBar @onSearch="search"></SearchBar>
            <div class="select" >
                <span v-if="multipleSelection.length>0">已选：{{multipleSelection.length}} <el-button type="danger" class="table-btns" @click="handleDeleteAll()">删除选中</el-button></span>
<!--                <el-button type="primary" class="table-btns" @click="showRequire()">新增</el-button>-->
            </div>
        </div>
        <el-table :data="tablePager.list" style="width: 100%" @selection-change="handleSelectionChange">
<!--            <el-table-column type="selection"  width="55"/>-->
<!--            <el-table-column type="index" label="序号" width="80"/>-->
            <el-table-column prop="hrwName" label="所属依托单位" />
            <el-table-column prop="projectName" label="提交平台名称" />
            <el-table-column prop="cname" label="仪器设备名称" />
            <el-table-column prop="worth" width="120" label="原值（万元）" />
            <el-table-column prop="logOffSubTime" label="提交时间" />
            <el-table-column prop="logOffStateStr" label="注销状态" />
            <el-table-column  label="操作" width="220">
                <template #default="scope">

                  <a v-if="scope.row.logOffState === 2" href="javascript:void(0)" class="danger" @click="updateLogOffState(1,scope.row.id)">允许注销</a>
                  <a v-if="scope.row.logOffState === 2" style="margin-left:20px;" href="javascript:void(0)" class="primary" @click="updateLogOffState(3,scope.row.id)">不允许注销</a>
                </template>
            </el-table-column>
        </el-table>
        <Pager :totalPage="tablePager.totalPage" :currentPage="currentPage" @pageChange="pageChange" class="pager"/>

        <el-dialog v-model="isShow" title="请填写您的需求">
            需求内容
        </el-dialog>
    </div>
</template>

<script>
import SearchBar from '../../../components/common/SearchBar'
import {ElTable, ElTableColumn, ElButton, ElDialog, ElResult, ElPopover, ElIcon} from 'element-plus';
import {MoreFilled} from '@element-plus/icons-vue'
import Pager from '../../../components/common/Pager'
import {ref, onMounted, getCurrentInstance} from 'vue';
export default {
    components: {SearchBar, ElTable, ElTableColumn, ElButton, ElIcon,ElDialog, ElResult, ElPopover, MoreFilled, Pager},
    setup(){
        const {proxy} = getCurrentInstance();
        const currentPage = ref(1);
        const loading = ref(false);
        const searchKey = ref('');
        const tablePager = ref({
            total: 1,
            page: 1,
            list: [{id:'1', name:"广东省中医证候临床研究重点实验室",
                deptName: "广东省中医院",
                type: '医学科学',
                year: '1999',
                result: '待提交', date: '2021-12-12'}]
        })

        function loadData(){
            loading.value = true;
            const url = '/hfapplication/gdsti/c/resourcesCatalogue/logOffYiqiList';
            proxy.$http.post(url, {limit: 10, offset: (currentPage.value-1)*10, searchKey: searchKey.value})
            .then(res=>{
                loading.value = false
                if(res.data.state == 0){
                    tablePager.value = res.data.result;
                }
            }).catch(err=>{
                loading.value = false
            })
        }

        function pageChange(index){
            currentPage.value = index;
            loadData();
        }

        function search(val){
            searchKey.value = val;
            pageChange(1);
        }

        const multipleSelection = ref([])
        function handleSelectionChange(selections){
            multipleSelection.value = selections;
        }

        //注销操作
        function updateLogOffState(status,dataTid){
          let msg = "";
          if(status === 1){
            msg = "确认要允许注销吗？注销后将无法启用！"
          }else if(status === 3){
            msg = "确认要不允许注销吗？不允许注销后平台负责人可再次发起注销申请。"
          }

          HFConfirm(msg, "", "warning", function(isConfirm){
            if(isConfirm){

              const url = '/hfapplication/biform/c/form/updateLogOffState.do';
              proxy.$http.post(url, {dataTid: dataTid,logOffState:status}).then(res => {
                if (res.data.state == 0) {
                  HFToastrTipResult(res.data);
                  loadData();
                }
              }).catch(err => {

              });

            }
          });


        }

        function indexFormatter(row, column, cellValue, index){
            return row+1+'';
        }

        function handleDelete(index){
            console.log(index)
        }

        function handleUpdate(index){

        }
        function handlePublish(index){
            
        }

        function handleDeleteAll(){

        }

        

        const isShow = ref(false)
        function showRequire(){
            isShow.value = true;
        }

        function statusFormatter(row, column, cellValue, index){
            if(cellValue == 1){
                return '已处理';
            }else{
                return '待处理';
            }
        }

        

        onMounted(()=>{
            loadData();
        })

        return {tablePager,pageChange, search,currentPage, multipleSelection, indexFormatter, statusFormatter,
        handleDelete, handleDeleteAll, handleSelectionChange, handleUpdate, handlePublish,
        isShow, showRequire,loading,updateLogOffState}
    }
}
</script>

<style lang="less" scoped>
@import 'public/static/css/userBaseInfo.less';

</style>

